import template from './footer.html';
import controller from './footer.controller';

let footerComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default footerComponent;



// WEBPACK FOOTER //
// ./client/app/common/footer/footer.component.js